module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image3_dochimom2-28785db0af1f705252ce5fda3c1ed79a.png";